module.exports = __webpack_public_path__ + "media/mathematics.50a48f74.mp4";